import { Component, HostListener } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Store } from '@ngxs/store';
import { LocalStoreService } from '@vandelft/modules/shared/services/local-store.service';
import { UsersService } from '@vandelft/modules/shared/services/users.service';
import { AuthState } from '@vandelft/modules/shared/state/auth';
import { ShowError } from '@vandelft/modules/shared/state/error';

@Component({
    selector: 'app-export-button',
    templateUrl: './export-button.component.html',
    standalone: false
})
export class ExportButtonComponent {
  public errors = [];
  public isRunning = false;

  public constructor(
    private readonly localStorageService: LocalStoreService,
    private readonly usersService: UsersService,
    private readonly storage: AngularFireStorage,
    private readonly auth: AngularFireAuth,
    private readonly store: Store,
  ) { }
  @HostListener('click')
  public async startExport(): Promise<void> {
    try {
      this.isRunning = true;
      await this.auth.signInWithEmailAndPassword('berry@thenextapp.nl', 'p&9B^E%s%92f^Y');


      const user = this.store.selectSnapshot(AuthState.user);
      const userId = user['id'];
      const ts = new Date().toISOString().replace(/[:.]/g, '-');

      const workOrderDrafts = await this.localStorageService.getWorkOrderDraftsRaw();
      const workOrders = await this.localStorageService.getWorkOrdersRaw();
      const reportDrafts = await this.localStorageService.getReportDraftsRaw();

      for (const workOrder of workOrders) {
        try {
          const ref = this.storage.ref(`exports/${ts}/${userId}/work-orders/${workOrder['id']}.json`);
          const workOrderData = JSON.stringify(workOrder);
          await ref.putString(workOrderData);
        } catch (error) {
          console.error(error);
          this.store.dispatch(new ShowError(`${error}`));
        }
      }


      for (const workOrderDraft of workOrderDrafts) {
        try {
          const ref = this.storage.ref(`exports/${ts}/${userId}/work-order-drafts/${workOrderDraft['id']}.json`);
          const workOrderDraftData = JSON.stringify(workOrderDraft);
          await ref.put(workOrderDraftData);
        } catch (error) {
          console.error(error);
          this.store.dispatch(new ShowError(`${error}`));
        }
      }

      for (const reportDraft of reportDrafts) {
        try {
          const ref = this.storage.ref(`exports/${ts}/${userId}/report-drafts/${reportDraft['id']}.json`);
          const reportData = JSON.stringify(reportDraft);
          await ref.putString(reportData);
        } catch (error) {
          console.error(error);
          this.store.dispatch(new ShowError(`${error}`));
        }
      }
    } catch (error) {
      console.error(error);
      this.store.dispatch(new ShowError(`${error}`));
    } finally {
      this.isRunning = false;
    }
  }
}
